import { useQuery, QueryResult } from '@apollo/client'
import { SCHEDULED_MEETINGS_BY_MANAGER } from '../MeetingQueries'
import { ScheduledMeetingsByManagerQuery, ScheduledMeetingsByManagerQueryVariables } from '../../../types'

export const useScheduledMeetingsByManager = (
  managerId: number,
  year: number,
): QueryResult<ScheduledMeetingsByManagerQuery, ScheduledMeetingsByManagerQueryVariables> => {
  return useQuery<ScheduledMeetingsByManagerQuery, ScheduledMeetingsByManagerQueryVariables>(SCHEDULED_MEETINGS_BY_MANAGER, {
    variables: {
      managerId,
      year,
    },
    fetchPolicy: 'cache-and-network',
  })
}
